
import React from 'react';

export const NodeTypeLegend: React.FC = () => {
  return (
    <div className="flex flex-wrap gap-3 justify-center mt-4 text-xs">
      <div className="flex items-center gap-1.5">
        <div className="w-3 h-3 rounded-full bg-blue-500"></div>
        <span>Gateway</span>
      </div>
      <div className="flex items-center gap-1.5">
        <div className="w-3 h-3 rounded-full bg-green-500"></div>
        <span>Relay</span>
      </div>
      <div className="flex items-center gap-1.5">
        <div className="w-3 h-3 rounded-full bg-purple-500"></div>
        <span>Endpoint</span>
      </div>
    </div>
  );
};
